<template>
    <footer class="layout-footer" v-if="appStore.showFooter">
        <div class="footer">
            <!-- 授权 -->
            <p
                class="all-right-reserved"
                v-if="showAuth && config.company?.company_name"
            >
                系统版权所有:
                <a href="https://www.uzesafe.com/" target="_blank">{{
                    copyright || '-'
                }}</a>
            </p>
            <p v-if="config.company?.company_name">
                <span v-if="showAuth">授权使用:</span>
                <span>{{ config.company?.company_name || '-' }}</span>
            </p>
            <!-- 经营许可证 -->
            <p v-if="config.company?.card_number">
                经营许可证号:
                <a
                    class="link"
                    :href="tmsLicenseUrl"
                    target="_blank"
                    :size="defaultFormSize"
                >
                    {{ config.company?.card_number || '-' }}
                </a>
            </p>
            <!-- 公安备案号 -->
            <p class="flex items-center" v-if="config.company?.public_security">
                <img
                    class="public-security-img"
                    src="@/assets/images/public_security.png"
                />
                公安备案号:
                <a
                    class="link"
                    :href="publicSecurityUrl"
                    target="_blank"
                    :size="defaultFormSize"
                >
                    {{ config.company?.public_security || '-' }}
                </a>
            </p>
            <!-- 网站备案号 -->
            <p v-if="config.company?.icp_code">
                ICP备案号:
                <a
                    class="link"
                    :href="icpCodeUrl"
                    target="_blank"
                    :size="defaultFormSize"
                >
                    {{ config.company?.icp_code || '-' }}
                </a>
            </p>
        </div>
    </footer>
</template>

<script setup lang="ts">
import sysConfig from '@/config/index'
import useAppStore from '@/stores/modules/app'
import { defaultFormSize } from '@/types'

const copyright = computed(() => sysConfig.copyright)
const appStore = useAppStore()
const config = computed(() => appStore.reConfig)
const showAuth = computed(() => {
    let auth = appStore.reConfig?.company?.show_company_auth
    auth = Number(auth)
    return !auth
})

// 增值电信许可证跳转链接
const tmsLicenseUrl = shallowRef('https://beian.miit.gov.cn/')

// ICP备案号跳转链接
const icpCodeUrl = shallowRef('https://beian.miit.gov.cn/')

// 公安备案号跳转链接
const publicSecurityUrl = computed(() => {
    const code = appStore.reConfig?.company?.public_security
    return `http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${code}`
})
</script>

<style lang="scss" scoped>
.layout-footer {
    // padding: 0 30px;
}
.footer {
    height: 50px;
    padding: 16px 0;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    overflow-x: auto;
    margin: 0 auto;
    > p {
        padding: 0 8px;
    }
    .public-security-img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
    }
    .link {
        display: inline-block;
        &:hover {
            color: var(--el-color-primary);
            font-weight: 700;
        }
    }
    .all-right-reserved {
        a {
            display: inline-block;
            font-weight: 700;
        }
    }
}
@media (max-width: 768px) {
    .footer {
        justify-content: flex-start;
    }
}
</style>
